export const getGridStyleOld = _ref => {
  let {
    layout,
    useCSSVars
  } = _ref;
  return {
    gridTemplateColumns: `repeat(${layout.columns}, 1fr)`,
    gridAutoRows: 'minmax(min-content, max-content) 1fr',
    columnGap: useCSSVars ? undefined : `${layout.margin.horizontal}px`
  };
};
export const getContainerStyle = _ref2 => {
  let {
    margin
  } = _ref2;
  return {
    gap: `${margin.vertical}px`
  };
};
export const getGridStyle = _ref3 => {
  let {
    layout,
    useCSSVars
  } = _ref3;
  return {
    gridTemplateColumns: `repeat(${layout.columns}, 1fr)`,
    gridAutoRows: '0fr minmax(max-content, 0fr)',
    columnGap: useCSSVars ? undefined : `${layout.margin.horizontal}px`,
    rowGap: 0
  };
};
//# sourceMappingURL=grid-options.js.map